// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__Mwv7+","checkbox--red":"Checkbox_checkbox--red__2yz0J","checkbox--green":"Checkbox_checkbox--green__gjryB"};